import { SideNavInterface } from "../../interfaces/side-nav.type";


export const INVESTOR_ROUTES: SideNavInterface[] = [
  {
    path: "/users",
    title: "Người dùng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "team",
    submenu: [
      {
        path: "/users/investor",
        title: "Nhà đầu tư",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [  
          {
            path: "/users/investor/sip",
            title: "Đăng ký SIP",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "user",
            submenu: [],
          },
          {
            path: "/users/investor/changed-profile",
            title: "Thay đổi thông tin nhà đầu tư",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "edit",
            submenu: [],
          },
          {
            path: "/users/investor/black-list",
            title: "Hạn chế giao dịch",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "edit",
            submenu: [],
          },
        ],
      },
     
    ],
  },
]
export const PRODUCT_ROUTES: SideNavInterface[] = [
  {
    path: "/products",
    title: "Sản phẩm",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "audit",
    submenu: [
      {
        path: "",
        title: "Chứng chỉ quỹ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [
          {
            path: "/products/fund",
            title: "Danh sách",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "audit",
            submenu: [],
          },
          {
            path: "/products/upload-nav",
            title: "NAV",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "audit",
            submenu: [],
          },
          {
            path: '/products/dividend',
            title: 'Chia cổ tức',
            iconType: 'nzIcon',
            iconTheme: 'outline',
            icon: 'container',
            submenu: []
          }
        ],
      },
      {
        path: "/products/sip",
        title: "SIP",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: []
      },
      {
        path: "/products/gold",
        title: "Vàng & Bạc",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: []
      }
    ],
  },
];
export const TRANSACTION_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Giao dịch",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/transactions/history",
        title: "Giao dịch",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "sync",
        submenu: [],
      },
      {
        path: "/transactions/trade-register",
        title: "Đăng ký giao dịch",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-sync",
        submenu: [],
      },
      {
        path: "/transactions/vsd-reconcile-history",
        title: "Lịch sử đối soát VSD",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-sync",
        submenu: [],
      },
    ],
  },
];
export const DASHBOARD_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Dashboard",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "home",
    submenu: [
      {
        path: "/dashboard",
        title: "CCQ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/dashboard/casa",
        title: "CASA",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
    ],
  }
];
export const QUERY_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Query",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "database",
    submenu: [
      {
        path: "/developer/query/history",
        title: "Query History",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/developer/query/execute",
        title: "Tạo Query",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
    ],
  },
];
export const FEE_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Tính phí",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/fee/fee-commission-receive",
        title: "Phí cty QLQ nhận được",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [],
      },
      {
        path: "",
        title: "Phí cty QLQ trả cho Fincorp",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [
          {
            path: "/fee/issuer/fee-declaration",
            title: "Khai báo phí",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "setting",
            submenu: [],
          },
          {
            path: "/fee/issuer/fee-commission",
            title: "Hoa hồng từng quỹ theo ngày",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "gift",
            submenu: [],
          },
          {
            path: "/fee/issuer/revenue-fm",
            title: "Doanh thu Fm",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "dollar",
            submenu: [],
          },
          {
            path: "/fee/issuer/reconcile-fees",
            title: "Đối soát phí",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "dollar",
            submenu: [],
          },
          {
            path: "/fee/issuer/export-file",
            title: "Export file",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "dollar",
            submenu: [],
          },
        ],
      },
      {
        path: "",
        title: "Phí Fincorp trả cho đối tác giới thiệu",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [
          {
            path: "/fee/agent/fee-declaration",
            title: "Khai báo phí",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "dollar",
            submenu: [],
          },
          {
            path: "/fee/agent/fee-commission",
            title: "Phí hoa hồng",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "gift",
            submenu: [],
          },
          {
            path: "/fee/agent/export-file",
            title: "Export file",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "gift",
            submenu: [],
          },
        ],
      },
      {
        path: "/fee/organization-agent/fee-commission",
        title: "Phí Fincorp trả cho đối tác tổ chức",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [],
      },
      {
        path: "",
        title: "Phí NH (Casa) trả cho Fincorp",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [
          {
            path: "/fee/casa/fee-declaration",
            title: "Khai báo phí",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "setting",
            submenu: [],
          },
          {
            path: "/fee/casa/export-file",
            title: "Export file",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "dollar",
            submenu: [],
          },
        ],
      },
    ],
  },
];

export const ACCOUNT_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Tài khoản",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "user",
    submenu: [
      {
        path: "/users/account/admin",
        title: "Admin",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "",
        title: "Tiểu khoản Vận hành",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [
          {
            path: "/users/account/fund-operator",
            title: "Danh sách",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "user",
            submenu: [],
          },
          {
            path: "/users/account/fund-operator-group",
            title: "Nhóm quyền",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "user",
            submenu: [],
          },
        ],
      },
      {
        path: "/users/account/sale",
        title: "Sale",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/users/account/marketing",
        title: "Marketing User",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/users/account/subdomain-account",
        title: "Subdomain",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
    ],
  },
];
export const USERS_ROUTES: SideNavInterface[] = [
  {
    path: "/users",
    title: "Người dùng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "team",
    submenu:
    [
      {
        path: "/users/investor",
        title: "Nhà đầu tư",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [
          {
            path: "/users/investor/normal",
            title: "Danh sách",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "user",
            submenu: [],
          },
          {
            path: "/users/investor/sip",
            title: "Đăng ký SIP",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "user",
            submenu: [],
          },
          {
            path: "/users/investor/changed-profile",
            title: "Thay đổi thông tin nhà đầu tư",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "edit",
            submenu: [],
          },
          {
            path: "/users/investor/black-list",
            title: "Hạn chế giao dịch",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "edit",
            submenu: [],
          },
        ],
      },
      {
        path: "/users/issuer",
        title: "Tổ chức phát hành",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "team",
        submenu: [],
      },
      {
        path: "/users/agent",
        title: "Đại lý",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "usergroup-add",
        submenu: [
          {
            path: "/users/agent/fund",
            title: "Đại lý phân phối CCQ",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "usergroup-add",
            submenu: [],
          },
          {
            path: "/users/agent/gold",
            title: "Đại lý phân phối Vàng",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "usergroup-add",
            submenu: [],
          },
          {
            path: "/users/agent/introduce",
            title: "Đại lý giới thiệu",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "usergroup-add",
            submenu: [],
          },
        ],
      },
      
    ],
  },
];
export const MARKETING_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Marketing",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "mail",
    submenu: [
      {
        path: "/marketing/program",
        title: "Chương trình",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "",
        title: "Reward",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [
          {
            path: "/marketing/reward",
            title: "Sản phẩm thưởng",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "gift",
            submenu: [],
          },
          {
            path: "/marketing/reward/wallet",
            title: "Ví thưởng",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "wallet",
            submenu: [],
          },
          {
            path: "/marketing/reward/config",
            title: "Cấu hình",
            iconType: "nzIcon",
            iconTheme: "outline",
            icon: "setting",
            submenu: [],
          },
        ],
      },
      {
        path: "/master-data/banner",
        title: "Banner",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },

      {
        path: "/marketing/config-mobile",
        title: "Cấu hình Mobile",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
];

export const CMS_ROUTES: SideNavInterface[] = [
  {
    path: "/cms",
    title: "CMS",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "setting",
    submenu: [
      {
        path: "/cms/block-type",
        title: "Loại Block",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "calculator",
        submenu: [],
      },
      {
        path: "/cms/home",
        title: "Trang chủ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "calculator",
        submenu: [],
      },
      {
        path: "/cms/platform",
        title: "Nền tảng",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/knowledge",
        title: "Kiến thức",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/user-guide",
        title: "Hướng dẫn sử dụng",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/qa",
        title: "Câu hỏi thường gặp",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/location",
        title: "Địa chỉ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/social",
        title: "Mạng xã hội",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/cms/support-info",
        title: "Tài khoản hỗ trợ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: '/cms/create/new-page',
        title: 'Tạo trang CMS',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
    ],
  },
];

export const MASTER_DATA_ROUTES: SideNavInterface[] = [
  {
    path: "/master-data",
    title: "Dữ liệu",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "database",
    submenu: [
      {
        path: "/master-data/ttlk",
        title: "Trung tâm lưu ký",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/master-data/holiday",
        title: "Ngày lễ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/master-data/issuer-holiday",
        title: "Ngày nghỉ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/master-data/bank",
        title: "Ngân hàng",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      // {
      //   path: '/master-data/company',
      //   title: 'Công ty',
      //   iconType: 'nzIcon',
      //   iconTheme: 'outline',
      //   icon: 'read',
      //   submenu: []
      // },
      {
        path: "/master-data/country",
        title: "Quốc gia",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/master-data/province",
        title: "Khu vực",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
];

export const MAIL_ROUTES: SideNavInterface[] = [
  {
    path: "/mail",
    title: "Mail",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "mail",
    submenu: [
      {
        path: "/mail/send-mail/investor",
        title: "Tất cả nhà đầu tư",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/mail/send-mail/issuer",
        title: "Tất cả nhà phát hành",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/mail/send-mail-user-product",
        title: "Mail cho user mua sản phẩm",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/mail/send-mail-delay-reconcile-order",
        title: "Dời ngày phân bổ quỹ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
];
export const FULL_ROUTES: SideNavInterface[] = [
  ...DASHBOARD_ROUTES,
  ...ACCOUNT_ROUTES,
  ...USERS_ROUTES,
  ...PRODUCT_ROUTES,
  ...TRANSACTION_ROUTES,
  ...FEE_ROUTES,
  ...MARKETING_ROUTES,
  // ...CMS_ROUTES,
  ...MASTER_DATA_ROUTES,
  ...MAIL_ROUTES,
  {
     path: "",
     title: "Đối tác",
     iconType: "nzIcon",
     iconTheme: "outline",
     icon: "global",
     submenu: [
       {
         path: "/settings/sub-domain",
         title: "Sublink",
         iconType: "nzIcon",
         iconTheme: "outline",
         icon: "link",
         submenu: [],
       },
       {
         path: "/master-data/third-party",
         title: "Third App",
         iconType: "nzIcon",
         iconTheme: "outline",
         icon: "share-alt",
         submenu: [],
       },
     ],
   },
   {
     path: "/settings",
     title: "Hệ thống",
     iconType: "nzIcon",
     iconTheme: "outline",
     icon: "setting",
     submenu: [
       {
         path: "/settings/system-config",
         title: "Cấu hình",
         iconType: "nzIcon",
         iconTheme: "outline",
         icon: "read",
         submenu: [],
       },
       {
         path: "/settings/e-sign",
         title: "E-Sign",
         iconType: "nzIcon",
         iconTheme: "outline",
         icon: "read",
         submenu: [],
       },
     ],
   },
 ];